import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { NgxCurrencyModule } from "ngx-currency";
import { SharedDirectivesModule } from 'src/app/directives/shared-directives.module';
import { MaterialCommonModule } from 'src/app/material-modules/material-common.module';
import { AlocacaoComponent } from '../../funcionario/alocacao/alocacao.component';
import { CadastrarAlocacaoComponent } from '../../funcionario/alocacao/cadastrar-alocacao/cadastrar-alocacao.component';
import { ListarAlocacaoComponent } from '../../funcionario/alocacao/listar-alocacao/listar-alocacao.component';
import { CadastroEnderecoModule } from '../cadastro-endereco/cadastro-endereco.module';
import { ComboEmpresaSocialModule } from '../combo-empresa-social/combo-empresa-social.module';
import { ComboPesquisavelModule } from '../combo-pesquisavel/combo-pesquisavel.module';
import { ComboProgramaModule } from '../combo-programa/combo-programa.module';
import { ComboProjetoModule } from '../combo-projeto/combo-projeto.module';
import { ComboTipoPublicoPrioritarioModule } from '../combo-tipo-publico-prioritario/combo-tipo-publico-prioritario.module';
import { ComboGrauInstrucaoModule } from '../combo-grau-instrucao/combo-grau-instrucao.module';
import { ComboTipoEscolaModule } from '../combo-tipo-escola/combo-tipo-escola.module';
import { ComboSerieEscolarModule } from '../combo-serie-escolar/combo-serie-escolar.module';
import { ComboTurnoModule } from '../combo-turno/combo-turno.module';
import { ComboMotivoDesligamentoModule } from '../combo-motivo-desligamento/combo-motivo-desligamento.module';
import { ComboMatriculaSecretariaModule } from '../combo-matricula-secretaria/combo-matricula-secretaria.module';
import {
  ComboTiposPublicosPrioritariosModule
} from '../combo-tipos-publicos-prioritarios/combo-tipos-publicos-prioritarios.module';
import { AcademicoComponent } from './academico/academico.component';
import { AtendimentoApoioComponent } from './atendimento-apoio/atendimento-apoio.component';
import { BeneficioSocialPessoaFisicaComponent } from './beneficio-social-pessoa-fisica/beneficio-social-pessoa-fisica.component';
import { DadosPessoaisComponent } from './dados-pessoais/dados-pessoais.component';
import { DadosProfissionaisComponent } from './dados-profissionais/dados-profissionais.component';
import { DocumentosComponent } from './documentos/documentos.component';
import { EscolarAlunoComponent } from './escolar-aluno/escolar-aluno.component';
import { EscolarComponent } from './escolar/escolar.component';
import { EscolaridadeComponent } from './escolaridade/escolaridade.component';
import { FormularioEncaminhamentoComponent } from './formulario-encaminhamento/formulario-encaminhamento.component';
import { FuncionalComponent } from './funcional/funcional.component';
import { OutrasInformacoesComponent } from './outras-informacoes/outras-informacoes.component';

@NgModule({
  declarations: [
    DadosPessoaisComponent,
    EscolaridadeComponent,
    DocumentosComponent,
    DadosProfissionaisComponent,
    OutrasInformacoesComponent,
    FuncionalComponent,
    AcademicoComponent,
    EscolarComponent,
    EscolarAlunoComponent,
    AtendimentoApoioComponent,
    FormularioEncaminhamentoComponent,
    BeneficioSocialPessoaFisicaComponent,
    AlocacaoComponent, ListarAlocacaoComponent, CadastrarAlocacaoComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MaterialCommonModule,
    NgxCurrencyModule,
    SharedDirectivesModule,
    CadastroEnderecoModule,
    ComboPesquisavelModule,
    ComboProgramaModule,
    ComboProjetoModule,
    ComboEmpresaSocialModule,
    ComboTipoPublicoPrioritarioModule,
    ComboGrauInstrucaoModule,
    ComboTipoEscolaModule,
    ComboSerieEscolarModule,
    ComboTurnoModule,
    ComboMotivoDesligamentoModule,
    ComboMatriculaSecretariaModule,
    ComboTiposPublicosPrioritariosModule
  ],
  exports:[
    DadosPessoaisComponent,
    EscolaridadeComponent,
    DocumentosComponent,
    DadosProfissionaisComponent,
    OutrasInformacoesComponent,
    FuncionalComponent,
    AcademicoComponent,
    EscolarComponent,
    EscolarAlunoComponent,
    AtendimentoApoioComponent,
    BeneficioSocialPessoaFisicaComponent
  ]
})
export class PessoaFisicaModule { }
